export default {
  Du: "invalid_api_key",
  Tu: "blacklisted",
  ku: "no_device_identifier",
  Au: "invalid_json_response",
  bu: "empty_response",
  __: "sdk_auth_error"
};